import { render } from "./OnCallView.vue?vue&type=template&id=ec574546"
import script from "./OnCallView.vue?vue&type=script&lang=js"
export * from "./OnCallView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__